import React, { Fragment, useContext, useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import style from "./profileSlider.module.css";

import { UserContext } from '../../Context/UserContext.js';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function ProfileSlider() {
   const { userToken } = useContext(UserContext);
   const [profiles, setProfiles] = useState([]);
   const [imageUrls, setImageUrls] = useState({}); // store blob URLs for images

   const header = {
      Authorization: `${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
   };

   // Fetch Profiles
   const getData = async () => {
      try {
         const { data } = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/v1/profile?filter=active`,
            { headers: header }
         );
         setProfiles(data?.profiles || []);
      } catch (error) {
         console.error("Error fetching profiles:", error);
      }
   };

   // Fetch each image as blob with token
   const fetchImageWithToken = async (profileId, imageUrl) => {
      try {
         const response = await axios.get(imageUrl, {
            headers: header,
            responseType: "blob",
         });
         const blobUrl = URL.createObjectURL(response.data);
         setImageUrls((prev) => ({ ...prev, [profileId]: blobUrl }));
      } catch (err) {
         console.error("Error fetching image for profile", profileId, err);
      }
   };

   // Load data + images
   useEffect(() => {
      getData();
   }, []);

   useEffect(() => {
      profiles.forEach((item) => {
         if (item.image && !imageUrls[item._id]) {
            fetchImageWithToken(item._id, item.image);
         }
      });
   }, [profiles]);

   const settings = {
      dots: true,
      infinite: profiles.length > 4,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      responsive: [
         {
            breakpoint: 500,
            settings: {
               slidesToShow: 1,
               infinite: profiles.length > 1,
            }
         }
      ]
   };

   return (
      <Fragment>
         <div className="p-4">
            {profiles.length >= 1 && (
               <Slider {...settings}>
                  {profiles.map((item) =>
                     item.isActive ? (
                        <Link to={`/ShowAnalysisProfile/${item._id}`} key={item._id}>
                           <div className="px-2">
                              <div className={`${style.card} border border-1`}>
                                 <img
                                    src={imageUrls[item._id]}
                                    alt={item.name}
                                    className={`${style.imageSlider}`}
                                 />
                                 {/* <p className={`${style.title} text-black text-center m-0 p-1 bg-body-tertiary`}>
                                    {item.name}
                                 </p> */}
                              </div>
                           </div>
                        </Link>
                     ) : null
                  )}
               </Slider>
            )}
         </div>
      </Fragment>
   );
}
